import { Injectable, inject } from '@angular/core';
import { GraphTooltipService } from '@molecules/graph-tooltip/graph-tooltip.service';
import { ControlPageStore } from '@pages/control-page/control-page-store.service';
import { map } from 'rxjs';

@Injectable()
export class ControlPageGraphTooltipService extends GraphTooltipService {
  controlPageStore = inject(ControlPageStore);

  measureCards$ = this.controlPageStore.datasets$;

  apiScale$ = this.controlPageStore.scale$.pipe(
    map(scale => this.controlPageStore.scaleToApiScale(scale)),
  );

  constructor() {
    super();
    this.createTooltip('cursor');
  }
}